
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/taxonomy/term/[copyOrMove]/batch/[id]",
      function () {
        return require("private-next-pages/taxonomy/term/[copyOrMove]/batch/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/taxonomy/term/[copyOrMove]/batch/[id]"])
      });
    }
  